import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { RegisterPage } from "./pages/RegisterPage"
import { LoginPage } from "./pages/LoginPage"
import { ChatPage } from "./pages/ChatPage"
import { Toaster } from "sonner"

export function App() {
  return (
    <Router>
      <Toaster
        toastOptions={{
          classNames: {
            toast: "border",
            error: "!bg-red-900/90 !border-red-500 !text-white",
            success: "!bg-green-900/90 !border-green-500 !text-white",
            warning: "!bg-yellow-900/90 !border-yellow-500 !text-white",
            info: "!bg-blue-900/90 !border-blue-500 !text-white",
            description: "!text-white/80",
          },
        }}
      />
      <Routes>
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  )
}
